import { Injectable } from '@angular/core';
import { Idle, InterruptSource } from '@ng-idle/core';
import { Interrupt } from '@ng-idle/core/lib/interrupt';

@Injectable({ providedIn: 'root' })
export class IdleService {

  constructor(private idle: Idle) {
  }

  setIdle(seconds: number): number {
    return this.idle.setIdle(seconds);
  }

  setTimeout(seconds: number | boolean): number {
    return this.idle.setTimeout(seconds);
  }

  setInterrupts(sources: InterruptSource[]): Interrupt[] {
    return this.idle.setInterrupts(sources);
  }

  clearInterrupts(): void {
    this.idle.clearInterrupts();
  }

  watch(skipExpiry?: boolean): void {
    return this.idle.watch(skipExpiry);
  }

  get onIdleEnd(): any {
    return this.idle.onIdleEnd;
  }

  get onTimeout(): any {
    return this.idle.onTimeout;
  }

  get onIdleStart(): any {
    return this.idle.onIdleStart;
  }

  get onTimeoutWarning(): any {
    return this.idle.onTimeoutWarning;
  }
}
